
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {ChartBarHistoryModifyResponse} from './ChartBarHistoryModifyResponse';
import {ChartBarPeriodType} from '../core/ChartBarPeriodType';
import {FieldModelChartBarPeriodType} from '../core/ChartBarPeriodType';

/**
 * ChartBarHistoryModifyRequest struct
 */
class ChartBarHistoryModifyRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!UUID=} symbolId
   * @param {!ChartBarPeriodType=} periodType
   * @param {!Date=} openTime
   * @param {number=} newOpenPrice
   * @param {number=} newHighPrice
   * @param {number=} newLowPrice
   * @param {number=} newClosePrice
   * @param {number=} newVolume
   * @constructor
   */
  constructor (parent = new Request(), symbolId = new UUID(), periodType = new ChartBarPeriodType(), openTime = new Date(0), newOpenPrice = null, newHighPrice = null, newLowPrice = null, newClosePrice = null, newVolume = null) {
    super()
    super.copy(parent)
    this.SymbolId = symbolId
    this.PeriodType = periodType
    this.OpenTime = openTime
    this.NewOpenPrice = newOpenPrice
    this.NewHighPrice = newHighPrice
    this.NewLowPrice = newLowPrice
    this.NewClosePrice = newClosePrice
    this.NewVolume = newVolume
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ChartBarHistoryModifyRequest}
   * @param {!ChartBarHistoryModifyRequest} other Other struct
   * @returns {!ChartBarHistoryModifyRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SymbolId != null) {
      this.SymbolId = new UUID(other.SymbolId)
    } else {
      this.SymbolId = null
    }
    if (other.PeriodType != null) {
      this.PeriodType = ChartBarPeriodType.fromObject(other.PeriodType)
    } else {
      this.PeriodType = null
    }
    if (other.OpenTime != null) {
      if (other.OpenTime instanceof Date) {
        this.OpenTime = new Date(other.OpenTime.getTime())
      } else {
        this.OpenTime = new Date(Math.round(other.OpenTime / 1000000))
      }
    } else {
      this.OpenTime = null
    }
    if (other.NewOpenPrice != null) {
      this.NewOpenPrice = other.NewOpenPrice
    } else {
      this.NewOpenPrice = null
    }
    if (other.NewHighPrice != null) {
      this.NewHighPrice = other.NewHighPrice
    } else {
      this.NewHighPrice = null
    }
    if (other.NewLowPrice != null) {
      this.NewLowPrice = other.NewLowPrice
    } else {
      this.NewLowPrice = null
    }
    if (other.NewClosePrice != null) {
      this.NewClosePrice = other.NewClosePrice
    } else {
      this.NewClosePrice = null
    }
    if (other.NewVolume != null) {
      this.NewVolume = UInt64.fromNumber(other.NewVolume)
    } else {
      this.NewVolume = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ChartBarHistoryModifyRequest}
   * @returns {!ChartBarHistoryModifyRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ChartBarHistoryModifyRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ChartBarHistoryModifyRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ChartBarHistoryModifyRequest}
   * @param {!ChartBarHistoryModifyRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ChartBarHistoryModifyRequest)) {
      throw new TypeError('Instance of ChartBarHistoryModifyRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ChartBarHistoryModifyRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SymbolId: ((this.SymbolId != null) ? this.SymbolId.toString() : null),
      PeriodType: ((this.PeriodType != null) ? this.PeriodType : null),
      OpenTime: ((this.OpenTime != null) ? (this.OpenTime.getTime() * 1000000) : null),
      NewOpenPrice: ((this.NewOpenPrice != null) ? this.NewOpenPrice : null),
      NewHighPrice: ((this.NewHighPrice != null) ? this.NewHighPrice : null),
      NewLowPrice: ((this.NewLowPrice != null) ? this.NewLowPrice : null),
      NewClosePrice: ((this.NewClosePrice != null) ? this.NewClosePrice : null),
      NewVolume: ((this.NewVolume != null) ? this.NewVolume.toNumber() : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ChartBarHistoryModifyRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ChartBarHistoryModifyRequest} other Object value
   * @returns {!ChartBarHistoryModifyRequest} Created struct
   */
  static fromObject (other) {
    return new ChartBarHistoryModifyRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ChartBarHistoryModifyRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ChartBarHistoryModifyRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ChartBarHistoryModifyRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 3010
  }
}

export { ChartBarHistoryModifyRequest };

/**
 * Fast Binary Encoding ChartBarHistoryModifyRequest field model
 */
class FieldModelChartBarHistoryModifyRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.SymbolId = new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.PeriodType = new FieldModelChartBarPeriodType(buffer, this.SymbolId.fbeOffset + this.SymbolId.fbeSize)
    this.OpenTime = new fbe.FieldModelTimestamp(buffer, this.PeriodType.fbeOffset + this.PeriodType.fbeSize)
    this.NewOpenPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OpenTime.fbeOffset + this.OpenTime.fbeSize), buffer, this.OpenTime.fbeOffset + this.OpenTime.fbeSize)
    this.NewHighPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewOpenPrice.fbeOffset + this.NewOpenPrice.fbeSize), buffer, this.NewOpenPrice.fbeOffset + this.NewOpenPrice.fbeSize)
    this.NewLowPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewHighPrice.fbeOffset + this.NewHighPrice.fbeSize), buffer, this.NewHighPrice.fbeOffset + this.NewHighPrice.fbeSize)
    this.NewClosePrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewLowPrice.fbeOffset + this.NewLowPrice.fbeSize), buffer, this.NewLowPrice.fbeOffset + this.NewLowPrice.fbeSize)
    this.NewVolume = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.NewClosePrice.fbeOffset + this.NewClosePrice.fbeSize), buffer, this.NewClosePrice.fbeOffset + this.NewClosePrice.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SymbolId.fbeSize + this.PeriodType.fbeSize + this.OpenTime.fbeSize + this.NewOpenPrice.fbeSize + this.NewHighPrice.fbeSize + this.NewLowPrice.fbeSize + this.NewClosePrice.fbeSize + this.NewVolume.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SymbolId.fbeExtra + this.PeriodType.fbeExtra + this.OpenTime.fbeExtra + this.NewOpenPrice.fbeExtra + this.NewHighPrice.fbeExtra + this.NewLowPrice.fbeExtra + this.NewClosePrice.fbeExtra + this.NewVolume.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelChartBarHistoryModifyRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 3010
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolId.fbeSize

    if ((fbeCurrentSize + this.PeriodType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PeriodType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PeriodType.fbeSize

    if ((fbeCurrentSize + this.OpenTime.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenTime.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenTime.fbeSize

    if ((fbeCurrentSize + this.NewOpenPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewOpenPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewOpenPrice.fbeSize

    if ((fbeCurrentSize + this.NewHighPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewHighPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewHighPrice.fbeSize

    if ((fbeCurrentSize + this.NewLowPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewLowPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewLowPrice.fbeSize

    if ((fbeCurrentSize + this.NewClosePrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewClosePrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClosePrice.fbeSize

    if ((fbeCurrentSize + this.NewVolume.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewVolume.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewVolume.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @param {!ChartBarHistoryModifyRequest} fbeValue Default value, defaults is new ChartBarHistoryModifyRequest()
   * @returns {!ChartBarHistoryModifyRequest} ChartBarHistoryModifyRequest value
   */
  get (fbeValue = new ChartBarHistoryModifyRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @param {!ChartBarHistoryModifyRequest} fbeValue ChartBarHistoryModifyRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolId.fbeSize) <= fbeStructSize) {
      fbeValue.SymbolId = this.SymbolId.get()
    } else {
      fbeValue.SymbolId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolId.fbeSize

    if ((fbeCurrentSize + this.PeriodType.fbeSize) <= fbeStructSize) {
      fbeValue.PeriodType = this.PeriodType.get()
    } else {
      fbeValue.PeriodType = new ChartBarPeriodType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PeriodType.fbeSize

    if ((fbeCurrentSize + this.OpenTime.fbeSize) <= fbeStructSize) {
      fbeValue.OpenTime = this.OpenTime.get()
    } else {
      fbeValue.OpenTime = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenTime.fbeSize

    if ((fbeCurrentSize + this.NewOpenPrice.fbeSize) <= fbeStructSize) {
      fbeValue.NewOpenPrice = this.NewOpenPrice.get()
    } else {
      fbeValue.NewOpenPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewOpenPrice.fbeSize

    if ((fbeCurrentSize + this.NewHighPrice.fbeSize) <= fbeStructSize) {
      fbeValue.NewHighPrice = this.NewHighPrice.get()
    } else {
      fbeValue.NewHighPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewHighPrice.fbeSize

    if ((fbeCurrentSize + this.NewLowPrice.fbeSize) <= fbeStructSize) {
      fbeValue.NewLowPrice = this.NewLowPrice.get()
    } else {
      fbeValue.NewLowPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewLowPrice.fbeSize

    if ((fbeCurrentSize + this.NewClosePrice.fbeSize) <= fbeStructSize) {
      fbeValue.NewClosePrice = this.NewClosePrice.get()
    } else {
      fbeValue.NewClosePrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClosePrice.fbeSize

    if ((fbeCurrentSize + this.NewVolume.fbeSize) <= fbeStructSize) {
      fbeValue.NewVolume = this.NewVolume.get()
    } else {
      fbeValue.NewVolume = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewVolume.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @param {!ChartBarHistoryModifyRequest} fbeValue ChartBarHistoryModifyRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelChartBarHistoryModifyRequest}
   * @param {ChartBarHistoryModifyRequest} fbeValue ChartBarHistoryModifyRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SymbolId.set(fbeValue.SymbolId)
    this.PeriodType.set(fbeValue.PeriodType)
    this.OpenTime.set(fbeValue.OpenTime)
    this.NewOpenPrice.set(fbeValue.NewOpenPrice)
    this.NewHighPrice.set(fbeValue.NewHighPrice)
    this.NewLowPrice.set(fbeValue.NewLowPrice)
    this.NewClosePrice.set(fbeValue.NewClosePrice)
    this.NewVolume.set(fbeValue.NewVolume)
  }
}

export { FieldModelChartBarHistoryModifyRequest };

/**
 * Fast Binary Encoding ChartBarHistoryModifyRequest model
 */
class ChartBarHistoryModifyRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelChartBarHistoryModifyRequest(this.buffer, 4)
  }

  /**
   * Get the ChartBarHistoryModifyRequest model
   * @this {!ChartBarHistoryModifyRequestModel}
   * @returns {!FieldModelChartBarHistoryModifyRequest} model ChartBarHistoryModifyRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ChartBarHistoryModifyRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ChartBarHistoryModifyRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ChartBarHistoryModifyRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ChartBarHistoryModifyRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelChartBarHistoryModifyRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ChartBarHistoryModifyRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ChartBarHistoryModifyRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ChartBarHistoryModifyRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ChartBarHistoryModifyRequestModel}
   * @param {!ChartBarHistoryModifyRequest} value ChartBarHistoryModifyRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ChartBarHistoryModifyRequestModel}
   * @param {!ChartBarHistoryModifyRequest} value ChartBarHistoryModifyRequest value, defaults is new ChartBarHistoryModifyRequest()
   * @return {!object} Deserialized ChartBarHistoryModifyRequest value and its size
   */
  deserialize (value = new ChartBarHistoryModifyRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ChartBarHistoryModifyRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ChartBarHistoryModifyRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ChartBarHistoryModifyRequestModel}
   * @param {!number} prev Previous ChartBarHistoryModifyRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ChartBarHistoryModifyRequestModel };
ChartBarHistoryModifyRequest.__has_response = true;
ChartBarHistoryModifyRequest.__response_class = ChartBarHistoryModifyResponse;
